/**
 * @description 获取浏览器信息
 * @returns browserName{浏览器名称}，browserVersion{浏览器版本}
 */

export function getBrowserInfo() {
  if (typeof navigator === 'undefined' || !navigator.userAgent) {
    return { browserName: "Unknown", browserVersion: "Unknown" };
  }
  const userAgent = navigator.userAgent;
  let browserName = 'Unknown', browserVersion = 'Unknown';

  // 检测 Chrome / Edge / Firefox / Safari / Opera
  if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
      browserName = "Chrome";
      browserVersion = userAgent?.match(/Chrome\/(\d+\.\d+)/)?.[1] || 'Unknown';
  } else if (userAgent.includes("Edg")) {
      browserName = "Edge";
      browserVersion = userAgent?.match(/Edg\/(\d+\.\d+)/)?.[1] || 'Unknown';
  } else if (userAgent.includes("Firefox")) {
      browserName = "Firefox";
      browserVersion = userAgent?.match(/Firefox\/(\d+\.\d+)/)?.[1] || 'Unknown';
  } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      browserName = "Safari";
      browserVersion = userAgent?.match(/Version\/(\d+\.\d+)/)?.[1] || 'Unknown';
  } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
      browserName = "Opera";
      browserVersion = userAgent?.match(/(?:Opera|OPR)\/(\d+\.\d+)/)?.[1] || 'Unknown';
  } else {
      browserName = "Unknown";
      browserVersion = "Unknown";
  }

  return {
    browserName,
    browserVersion,
    osVersion: `${browserName}${browserVersion}`,
    language: navigator.language,
  };
}